import { FunctionComponent } from 'react';
import { ListItemButton, ListItemText, Chip, Box, Skeleton, styled } from '@mui/material'
import SkeletonExt from '@/components/layouts/SkeletonExt';


interface IPatientListItemSkeleton {}


const LabelContainer = styled('div')({
    display: 'flex'
});

const TreatmentArmChip = styled(Chip)({
    marginLeft: 'auto'
});

const PatientListItemSkeleton: FunctionComponent<IPatientListItemSkeleton> = ({}) => {
    return (
        <ListItemButton>
            <ListItemText
                primary={
                    <SkeletonExt variant="text" minWidth={80} maxWidth={120} />
                }
            />
        </ListItemButton>
    );
}

export default PatientListItemSkeleton;